import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { DIVIDERS } from 'common/constants';

import styles from './Divider.css';

const cx = classnames.bind(styles);

const Divider = ({layout}) => <hr className={cx('divider', layout)} />;

Divider.propTypes = { layout: PropTypes.oneOf(Object.values(DIVIDERS)) };
Divider.displayName = 'Divider';

export default Divider;



// WEBPACK FOOTER //
// ./src/uis/elements/Divider/Divider.js